import { Routes, Route } from 'react-router-dom';import Home from './Home';
import Fashion from './Portfolio_Pages/Fashion';
import Art from './Portfolio_Pages/Art.js';
import Code from './Portfolio_Pages/Code.js';

function App() {
  return (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fashion" element={<Fashion />} />
          <Route path="/art" element={<Art />} />
          <Route path="/gamedev" element={<Code />} />
        </Routes>
  );
}

export default App;
